export const workOrderKeys = {
  getOperationId: (machineId?: string | null) =>
    ["workOrderOperationId", machineId] as const,
  getOperation: (id?: string | null, machine?: string | null) => [
    "workOrderOperation",
    id,
    machine,
  ],
  get: (id?: string | null) => ["workOrder", id],
};
